import React from 'react';
import { Helmet } from 'react-helmet-async';
import { GoogleMapsProvider } from 'common/google-map-context';
const NotFound = () => (<GoogleMapsProvider>
        <div className="NotFound">
            {/* @ts-expect-error - Added until we upgrade helmet */}
            <Helmet>
                <title>D&apos;oh! This page doesn&apos;t exist.</title>
                <body className="standalone-page"/>
            </Helmet>
            <div className="NotFound-hero">
                <h1 className="NotFound-error-code">404</h1>
                <div className="NotFound-content-wrap">
                    <div className="NotFound-content">
                        <h2 className="NotFound-error-message">
                            Looks like you made a wrong turn.
                            <br />
                            This page doesn&apos;t exist.
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    </GoogleMapsProvider>);
export default NotFound;
